import moment from 'moment'
import { groupBy, forEach, toPairs, isUndefined, isNull, cloneDeep } from 'lodash'

import types from '../store/globaltypes'
import { isMobileApp } from '../helpers/platform'

const MAX_NOTIFICATIONS = 32

function createNotificationText (actions) {
  return actions.map(action => {
    const m = action.methodID
    const s = action.stepID
    const c = action.crop.post_title
    const a = action.crop[`method${m}action${s}_action_type`]
    return ` • ${c}: ${a}`
  }).join('\r\n')
}

function createNotificationForDay (id, actions, hour, minute) {
  const title = actions.length === 1 ? '1 taak vandaag' : `${actions.length} taken vandaag`
  actions = actions.slice(0, 3)
  if (actions.length < 1) return null
  const text = createNotificationText(actions)
  const t = actions[0].period
  const trigger = { at: new Date(t.year(), t.month(), t.date(), hour, minute) }
  const foreground = true
  const wakeup = true
  const launch = true
  const silent = false
  return { id, title, text, trigger, foreground, wakeup, launch, silent }
}

function createNotificationForWeek (id, actions, date) {
  const title = actions.length === 1 ? '1 taak deze week' : `${actions.length} taken deze week`
  actions = actions.slice(0, 3)
  if (actions.length < 1) return null
  const text = createNotificationText(actions)
  const trigger = { at: date }
  const foreground = true
  const wakeup = true
  const launch = true
  const silent = false
  return { id, title, text, trigger, foreground, wakeup, launch, silent }
}

export default {

  getIntervalSetting () {
    return parseFloat(localStorage.getItem('notifications_interval') || 1)
  },

  getHourSetting () {
    const time = localStorage.getItem('notifications_time')
    if (!time) return '09'
    return time.split(':')[0]
  },

  getMinuteSetting () {
    const time = localStorage.getItem('notifications_time')
    if (!time) return '00'
    return time.split(':')[1]
  },

  getWeekDaySetting () {
    const day = localStorage.getItem('notifications_week_day')
    if (isNull(day)) return 0
    return parseFloat(day)
  },

  setIntervalSetting (val) {
    localStorage.setItem('notifications_interval', parseFloat(val))
  },

  setTimeSetting (val) {
    localStorage.setItem('notifications_time', val)
  },

  setWeekDaySetting (val) {
    localStorage.setItem('notifications_week_day', val)
  },

  setupNotificationHandler (router, store, welcomeMessageTitle) {
    if (isMobileApp()) {
      cordova.plugins.notification.local.on('click', (notification) => {
        if (notification.title === welcomeMessageTitle) return
        router.push({ name: 'calendar' })
        store.commit(types.ui.mutations.setSelectedDate, moment())
      })
    }
  },

  sendWelcomeMessage (title, text) {
    if (!isMobileApp()) return
    if (localStorage.getItem('sent_welcome_message') === '1') return
    
    const foreground = true
    const notification = { title, text, foreground }
    cordova.plugins.notification.local.schedule(notification)
    localStorage.setItem('sent_welcome_message', '1')
  },

  hasPermission () {
    return new Promise((resolve) => {
      if (!isMobileApp()) return resolve(false)
      cordova.plugins.notification.local.hasPermission(granted => {
        resolve(granted)
      })
    })
  },

  requestPermission () {
    return new Promise((resolve) => {
      if (!isMobileApp()) return resolve(true)

      if (this.getIntervalSetting() !== 0) {

        this.hasPermission().then(hasPermission => {
          if (hasPermission) {
            resolve(true)
            return
          }
          cordova.plugins.notification.local.requestPermission(val => {
            resolve(val)
          })
        })
      } else {
        resolve(false)
      }
    })
  },

  getTime () {
    const hour = parseFloat(this.getHourSetting())
    const minute = parseFloat(this.getMinuteSetting())
    return { hour, minute, second: 0 }
  },

  schedule (actions, hour) {
    if (isMobileApp()) {
      cordova.plugins.notification.local.cancelAll()
    }

    actions = cloneDeep(actions).filter(action => isUndefined(action.sendNotifications) || action.sendNotifications)
    hour = hour || 9
    let id = 1
    if (this.getIntervalSetting() === 1) {
      const today = moment().format('YYYY-MM-DD')
      const todayNotificationTime = moment().set(this.getTime())
      const shouldIncludeToday = moment().isBefore(todayNotificationTime)

      const daysGrouped = groupBy(actions, action => action.period.format('YYYY-MM-DD'))
      const days = toPairs(daysGrouped)
        .sort(x => x[0])
        .filter(x => shouldIncludeToday || x[0] !== today)
        .slice(0, MAX_NOTIFICATIONS)

      console.log('---notifications daily---')
      forEach(days, ([date, day]) => {
        const { hour, minute } = this.getTime()
        const notification = createNotificationForDay(id, day, hour, minute)
        console.log(id, JSON.stringify(notification))
        if (notification && isMobileApp()) {
          cordova.plugins.notification.local.schedule(notification)
        }
        id++
      })
    } else if (this.getIntervalSetting() === 2) {


      const firstDayOfWeek = moment().startOf('week').add(this.getWeekDaySetting(), 'days').dayOfYear() % 7
      const groupFunc = period => period.year() * 100 + Math.floor((period.dayOfYear() - firstDayOfWeek) / 7)

      let keyMap = {}
      let d = moment().add(-7, 'days')
      for (let i = 0; i < 1000; i++) {
        const g = groupFunc(d)
        if (isUndefined(keyMap[g])) keyMap[g] = moment(d)
        d.add(1, 'days')
      }

      const weeksGrouped = groupBy(actions, action => groupFunc(action.period))
      const weeks = toPairs(weeksGrouped)
        .sort(x => x[0])
        .slice(0, MAX_NOTIFICATIONS)

      console.log('---notifications weekly---')
      const weekDay = this.getWeekDaySetting()
      forEach(weeks, ([key, actions]) => {
        const { hour, minute } = this.getTime()
        const t = keyMap[key]
        const date = new Date(t.year(), t.month(), t.date(), hour, minute)
        const notification = createNotificationForWeek(id, actions, date)
        console.log(id, date, notification.trigger, notification.period)
        if (notification && isMobileApp()) {
          cordova.plugins.notification.local.schedule(notification)
        }
        id++
      })
    } else {
      console.log('---no notifications---')
    }
  }
}
